import { ThemeProvider } from 'styled-components';
import { theme } from './theme';
import React from 'react';
interface ThemeProps {
  children: React.ReactNode;
}
export const Theme: React.FC<ThemeProps> = ({ children }) => (
  <ThemeProvider theme={theme}>{children}</ThemeProvider>
);
